import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-voyage-log',
  templateUrl: 'voyage-log.html',
})
export class VoyageLogPage {

  config = AppConfig.settings;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/voyage-log/voyage-log/voyage-log.ts